import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "./App";

/* ============================================================
   Get the extension — now a logged-in-only page.
   Reachable at /get-extension (and the legacy hidden URL).
   ============================================================ */
export default function GetExtension() {
  return (
    <main>
      <section className="about-hero">
        <span className="mono-label">Members only</span>
        <h1 style={{ fontSize: "clamp(48px, 6vw, 96px)" }}>
          Fact-check the page you&rsquo;re <em>reading.</em>
        </h1>
        <p className="lead">
          Install the Chrome extension to automatically scan any article or social post
          and pull verdicts in-line.
        </p>
      </section>

      <section className="extension-grid">
        <div className="extension-card">
          <span className="mono-label">Step 01</span>
          <h3>Download</h3>
          <p>Grab the latest build below. The file is a ZIP — your browser will save it to Downloads.</p>
          <a className="btn btn-green" href="/extension/factornot-extension.zip" download>
            Download for Chrome →
          </a>
        </div>
        <div className="extension-card">
          <span className="mono-label">Step 02</span>
          <h3>Extract</h3>
          <p>Right-click the downloaded ZIP and choose <strong>Extract all</strong>. Pick a folder you won&rsquo;t accidentally delete.</p>
        </div>
        <div className="extension-card">
          <span className="mono-label">Step 03</span>
          <h3>Install in Chrome</h3>
          <p>
            Open <code>chrome://extensions</code>, flip on <strong>Developer mode</strong> in the top-right,
            then click <strong>Load unpacked</strong> and pick the folder you just extracted.
          </p>
        </div>
        <div className="extension-card">
          <span className="mono-label">Step 04</span>
          <h3>Use it</h3>
          <p>Browse any article. Click the FactOrNot icon in your toolbar to scan the page for claims and see in-line verdicts.</p>
          <Link to="/" className="btn btn-line" style={{ color: "var(--ink)", borderColor: "var(--hair-strong)" }}>
            Back to home
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}